import React from "react";
import { View, Image, StyleSheet } from "react-native";


const LogoScreen = ({ navigation }) => {
    return(
        <Image style={styles.logoStyles} source={require("../assets/Icon.jpg")}/>
    );
};

export default LogoScreen

const styles = StyleSheet.create({
    logoStyles: {
        height: 45,
        width: 110,
    },
});
